import styled from "styled-components";
import { breakpoints } from "styles";
import { Button } from "components/atoms/button/button";

export const CardHeading = styled.h1`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["2hxl"]};
  line-height: 40px;
  color: ${({ theme }) => theme.colors.neutral[900]};
  margin: 0;
`;

export const InfoBanner = styled.div`
  background-color: ${({ theme }) => theme.colors.blue[50]};
  border: 1px solid ${({ theme }) => theme.colors.blue[50]};
  border-radius: 8px;
  padding: 20px;
  margin: 24px 0;
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const InfoText = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  line-height: 20px;
  color: ${({ theme }) => theme.colors.blue[800]};
  margin: 0;
`;

export const CompleteProfileWrapper = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: flex-end;

  @media ${breakpoints.tablet} {
    margin-top: 16px;
  }
`;

export const CompleteProfile = styled(Button)`
  width: 100%;
  @media ${breakpoints.tablet} {
    width: auto;
  }
`;

export const InfoIconWrapper = styled.div`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 2.5px;
  margin-left: 2px;
`;
